import { BaseButton } from '@/shared/components'
import { ReactNode } from 'react'

type Option = {
  value: string
  label: string
  icon?: ReactNode
}

type Props = {
  options: Option[]
  value?: string[] // для множественного выбора
  singleValue?: string // для одиночного выбора
  onChange?: (values: string[]) => void
  onSingleChange?: (value: string) => void
  multiple?: boolean
  className?: string
  buttonClassName?: string
  size?: 'default' | 'icon'
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'
  padding?: 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'empty'
}

export const BaseButtonGroup = ({
  options,
  value = [],
  singleValue,
  onChange,
  onSingleChange,
  multiple = false,
  className = '',
  buttonClassName = '',
  size = 'default',
  radius = '2xl',
  padding = 'md',
}: Props) => {
  const handleButtonClick = (optionValue: string) => {
    if (multiple) {
      const newValue = value.includes(optionValue)
        ? value.filter((v) => v !== optionValue)
        : [...value, optionValue]
      onChange?.(newValue)
    } else {
      onSingleChange?.(optionValue)
    }
  }

  const isSelected = (optionValue: string) => {
    if (multiple) {
      return value.includes(optionValue)
    }
    return singleValue === optionValue
  }

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {options.map((option) => (
        <BaseButton
          key={option.value}
          variant={isSelected(option.value) ? 'primary' : 'outlined'}
          size={size}
          radius={radius}
          padding={padding}
          onClick={() => handleButtonClick(option.value)}
          icon={option.icon}
          className={buttonClassName}
        >
          {option.label}
        </BaseButton>
      ))}
    </div>
  )
}
